<script setup>

</script>
<template>
  <div class="font-weight-light">
    <slot/>
  </div>
</template>
